export default __webpack_public_path__ + "static/media/Notifications1.6c569603.svg";